import { FunctionComponent } from "react";
import { useAppSelector } from "@store/store";
import { selectClient } from "@store/client/clientReducer";
import { useHover } from "@hooks/useHover/useHover";

import "./MenuItem.css";

interface MenuItemProps {
  children: React.ReactNode;
  className?: string;
  inactiveIconUrl: string;
  activeIconUrl: string;
  handlePress: (event: React.MouseEvent<HTMLElement>) => void;
  label: string;
}

export const MenuItem: FunctionComponent<MenuItemProps> = ({
  children,
  className = "",
  inactiveIconUrl,
  activeIconUrl,
  handlePress,
  label,
}) => {
  const client = useAppSelector(selectClient);
  const { hoverRef, isHovered } = useHover<HTMLLIElement>();

  return (
    <li
      ref={hoverRef}
      className={`kiosk-menu-item ${className}`}
      data-testid="kiosk-menu-item"
      style={{
        backgroundColor: client.kioskFeature.menuBackgroundColor,
        boxShadow: client.kioskFeature.shadow,
        flexDirection:
          client.kioskFeature.labelPosition === "top"
            ? "column-reverse"
            : "column",
      }}
      onClick={handlePress}>
      <img
        src={isHovered ? activeIconUrl : inactiveIconUrl}
        alt={`${label} icon`}
      />
      <div
        className="kiosk-menu-item-content"
        style={{
          color: client.kioskFeature.textColor,
        }}>
        {children}
      </div>
    </li>
  );
};
